import styleContent from './additional-editor-styles.css';

const additionalEditorStyles = (liveDOM) => {
  const styleElement = liveDOM.createElement('style');
  styleElement.setAttribute('data-additional-editor-stylesheet', true);
  styleElement.innerHTML = styleContent;
  liveDOM.body.insertAdjacentElement('beforeend', styleElement);
};

export default additionalEditorStyles;
